<div class="create-dialog-box scrollable-dialog">
    <div class="title d-flex align-items-center justify-content-space-between">
        <h4 class="mb-0" [innerHTML]="data.notice_title | safeNotice "></h4>
        <button
            class="close-btn bg-transparent p-0 border-none"
            (click)="close()"
            (click)="markAsRead()"
        >
            <i class="flaticon-close"></i>
        </button>
    </div>

    <mat-card class="breadcrumb-card d-md-flex notice-content-space" *ngIf="data.notice_description">
        <mat-card-content class="mb-0 notice-content">
            <div [innerHTML]="data.notice_description | safeNotice "></div>
        </mat-card-content>
    </mat-card>
    <mat-card
        class="breadcrumb-card d-md-flex notice-content-space"
        *ngIf="data.imagePath"
    >
        <mat-card-content class="mb-0 notice-content">
            <!-- Image display section -->
            <div>
                <ng-container *ngIf="data.imagePath; else fallbackImage">
                    <img [src]="university_details.image" alt="Notice Image" class="notice-image" loading="lazy" />
                </ng-container>
                <ng-template #fallbackImage>
                    <img
                        [src]="university_details?.image"
                        alt="No Image Uploaded"
                    />
                </ng-template>
            </div>
        </mat-card-content>
    </mat-card>
    <mat-card-content class="footer text-end">
        <button
            mat-flat-button
            type="button"
            class="tagus fw-semibold ms-5 mt-10"
            (click)="markAsRead()"
        >
            <i class="ri-check-double-fill"></i> &nbsp;
            <span class="tagus-font">Mark As Read</span>
        </button>
    </mat-card-content>
</div>
